/* =====================================================================
   WAVEFORM — global chrome behaviors
   Mega menu, sticky-header condense, iOS safe-area "safe-stuck" toggle,
   announcement countdown + dismiss, mobile menu, footer localization
   selector, header search. All bindings are defensive (null-checked) and
   re-run on Shopify theme-editor section reloads.
   ===================================================================== */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- mega menu (hover + click + keyboard) ---------- */
  function initMegaMenu(scope) {
    var items = $$('.nav-item.has-mega', scope);
    if (!items.length) return;

    function syncMega() {
      items.forEach(function (i) {
        var b = i.querySelector('button');
        if (b) b.setAttribute('aria-expanded', i.classList.contains('open') ? 'true' : 'false');
      });
    }
    function closeAll() { items.forEach(function (i) { i.classList.remove('open'); }); syncMega(); }
    var hoverable = window.matchMedia('(hover: hover) and (min-width: 1025px)');

    items.forEach(function (item) {
      if (item.dataset.megaInit) return;
      item.dataset.megaInit = '1';
      var btn = item.querySelector('button');
      if (btn) { btn.setAttribute('aria-haspopup', 'true'); btn.setAttribute('aria-expanded', 'false'); }
      item.addEventListener('mouseenter', function () { if (!hoverable.matches) return; closeAll(); item.classList.add('open'); syncMega(); });
      item.addEventListener('mouseleave', function () { if (!hoverable.matches) return; item.classList.remove('open'); syncMega(); });
      item.addEventListener('focusin', function () { if (!hoverable.matches) return; closeAll(); item.classList.add('open'); syncMega(); });
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) { item.classList.remove('open'); syncMega(); } });
      if (btn) btn.addEventListener('click', function (e) {
        e.preventDefault();
        var was = item.classList.contains('open');
        closeAll();
        if (!was) item.classList.add('open');
        syncMega();
      });
    });

    if (!document.documentElement.dataset.megaDocInit) {
      document.documentElement.dataset.megaDocInit = '1';
      document.addEventListener('click', function (e) { if (!e.target.closest('.nav-item.has-mega')) closeAll(); });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        var openItem = $('.nav-item.has-mega.open');
        if (openItem) { closeAll(); var b = openItem.querySelector('button'); if (b) b.focus(); }
      });
    }
  }

  /* ---------- sticky header: condense + iOS safe-stuck (HANDOFF §4f) ---------- */
  function initHeader() {
    var header = $('.header');
    if (!header || header.dataset.scrollInit) return;
    header.dataset.scrollInit = '1';
    var announce = $('.announce');
    function onScroll() {
      header.classList.toggle('condensed', window.scrollY > 12);
      /* pad under the Dynamic Island only when the announce bar has
         scrolled away and the header is the top-most element */
      var ah = (announce && !announce.hidden && getComputedStyle(announce).display !== 'none') ? announce.offsetHeight : 0;
      header.classList.toggle('safe-stuck', window.scrollY >= ah - 1);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var mt = $('.menu-toggle'), nav = $('.header .nav'), scrim = $('[data-nav-scrim]');
    if (!mt || !nav || mt.dataset.menuInit) return;
    mt.dataset.menuInit = '1';
    mt.setAttribute('aria-haspopup', 'true');
    mt.setAttribute('aria-expanded', 'false');
    if (nav.id) mt.setAttribute('aria-controls', nav.id);

    var ICON_MENU = mt.innerHTML;
    var ICON_X = '<svg aria-hidden="true" focusable="false"><use href="#icon-x"/></svg>';

    function setOpen(open) {
      nav.classList.toggle('open', open);
      if (scrim) scrim.classList.toggle('show', open);
      document.documentElement.classList.toggle('nav-locked', open);
      mt.setAttribute('aria-expanded', open ? 'true' : 'false');
      mt.innerHTML = open ? ICON_X : ICON_MENU;
    }
    function isOpen() { return nav.classList.contains('open'); }

    mt.addEventListener('click', function () { setOpen(!isOpen()); });
    if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    nav.addEventListener('click', function (e) {
      /* navigating away — close so back/bfcache restores don't trap the scrim */
      if (e.target.closest('a[href]')) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) { setOpen(false); mt.focus(); }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024 && isOpen()) setOpen(false);
    });
  }

  /* ---------- announcement bar: countdown + dismiss ---------- */
  function initAnnouncement(scope) {
    $$('.announce', scope).forEach(function (bar) {
      if (bar.dataset.announceInit) return;
      bar.dataset.announceInit = '1';

      var key = 'waveform-announce-dismissed:' + (bar.dataset.dismissKey || 'default');
      try { if (bar.dataset.dismissible === 'true' && sessionStorage.getItem(key)) { bar.hidden = true; return; } } catch (e) {}

      var close = bar.querySelector('.close');
      if (close) close.addEventListener('click', function () {
        bar.hidden = true;
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        window.dispatchEvent(new Event('scroll'));
      });

      /* server-trusted countdown: the end time comes from a section setting,
         rendered as a unix epoch — never a client-side offset */
      var cd = bar.querySelector('[data-countdown-to]');
      if (cd) {
        var end = parseInt(cd.dataset.countdownTo, 10) * 1000;
        function p(n) { return (n < 10 ? '0' : '') + n; }
        function tick() {
          var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
          var d = Math.floor(s / 86400);
          var h = Math.floor((s % 86400) / 3600);
          var text = d > 0
            ? d + 'd ' + p(h) + ':' + p(Math.floor((s % 3600) / 60)) + ':' + p(s % 60)
            : p(Math.floor(s / 3600)) + ':' + p(Math.floor((s % 3600) / 60)) + ':' + p(s % 60);
          cd.textContent = text;
          if (s <= 0) { clearInterval(t); if (bar.dataset.hideWhenEnded === 'true') { bar.hidden = true; window.dispatchEvent(new Event('scroll')); } }
        }
        tick();
        var t = setInterval(tick, 1000);
      }
    });
  }

  /* ---------- footer localization selector ({% form 'localization' %}) ---------- */
  function initLocalization(scope) {
    $$('.cur-select', scope).forEach(function (wrap) {
      if (wrap.dataset.curInit) return;
      wrap.dataset.curInit = '1';
      var btn = wrap.querySelector('button.currency');
      var input = wrap.querySelector('input[name="country_code"]');
      var form = wrap.closest('form');
      if (!btn) return;

      function open() { wrap.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
      function close() { wrap.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); }
      btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); wrap.classList.contains('open') ? close() : open(); });
      document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      $$('.cur-opt', wrap).forEach(function (opt) {
        opt.addEventListener('click', function () {
          if (input) input.value = opt.dataset.value;
          close();
          if (form) form.submit();
        });
      });
    });
  }

  /* ---------- header search → search page ---------- */
  function initSearch() {
    $$('.search-btn').forEach(function (b) {
      if (b.dataset.searchInit) return;
      b.dataset.searchInit = '1';
      b.addEventListener('click', function () {
        var field = document.getElementById('searchField');
        if (field) { field.focus(); return; }
        window.location.href = b.dataset.searchUrl || '/search';
      });
    });
  }

  /* ---------- small press feedback + "Added" confirm ---------- */
  window.WaveformBump = function (btn) {
    btn.style.transform = 'translateY(1px) scale(0.99)';
    setTimeout(function () { btn.style.transform = ''; }, 130);
  };
  window.WaveformAdded = function (btn) {
    window.WaveformBump(btn);
    if (btn.dataset.addedActive) return;
    btn.dataset.addedActive = '1';
    var orig = btn.innerHTML;
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 6.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg> ' + (btn.dataset.addedText || (window.WaveformStrings && window.WaveformStrings.added) || 'Added');
    setTimeout(function () { btn.innerHTML = orig; delete btn.dataset.addedActive; }, 1300);
  };

  /* ---------- light/dark visitor toggle ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-theme-toggle]');
    if (!t) return;
    var d = document.documentElement;
    var next = d.getAttribute('data-theme') === 'light' ? 'dark' : 'light';
    d.setAttribute('data-theme', next);
    d.removeAttribute('data-theme-auto');
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', next === 'light' ? '#FAFAFC' : '#0A0B0E');
    try { localStorage.setItem('waveform-theme', next); } catch (err) {}
    if (window.WaveformBump) window.WaveformBump(t);
  });

  /* scroll-reveal: fade/slide sections in as they enter the viewport.
     Honored only when the global toggle is on and motion isn't reduced. */
  function initReveal(scope) {
    scope = scope || document;
    if (document.documentElement.getAttribute('data-animate') === 'off') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = $$('.reveal:not(.is-in)', scope);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- back-to-top button (global, wired once) ---------- */
  function initBackToTop() {
    var btn = $('[data-back-to-top]');
    if (!btn || btn.dataset.wired) return;
    btn.dataset.wired = '1';

    var threshold = 500; // px scrolled before the button appears

    function onScroll() {
      if (window.pageYOffset > threshold) { btn.classList.add('is-visible'); }
      else { btn.classList.remove('is-visible'); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    btn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function initAll(scope) {
    initMegaMenu(scope);
    initHeader();
    initMobileMenu();
    initAnnouncement(scope);
    initLocalization(scope);
    initSearch();
    initReveal(scope);
    initBackToTop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  /* re-init when the theme editor reloads a section */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
